export const invoicesConstants = {
  GET_INVOICES_REQUEST: 'GET_INVOICES_REQUEST',
  GET_INVOICES_SUCCESS: 'GET_INVOICES_SUCCESS',
  GET_INVOICES_FAILURE: 'GET_INVOICES_FAILURE',
  UPDATE_INVOICES_COMMENTS: 'UPDATE_INVOICES_COMMENTS',
  };
  